import { React, useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import 'react-phone-input-2/lib/style.css';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import PhoneInput from 'react-phone-input-2';
import LeaseApiService from '../../services/apiService';

const AgentPersonalDetails = ({ tableLoading, rowData, setTransectionData, transectionData, customerTypeList, salesPersonList, defaultCountry }) => {
    const apiService = new LeaseApiService();

    const handleDateChange = async (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;
        setTransectionData((prev) => ({
            ...prev,
            [name]: value
        }));
    }
    const handleInputChange = (input) => {
        const name = input?.target?.name || input.name;
        const value = input?.target?.value || input.value;

        setTransectionData((prev) => {
            const updatedData = { ...prev, [name]: value };
            if (name === "firstName" || name === "lastName") {
                updatedData.fullName = `${updatedData.firstName || ""} ${updatedData.lastName || ""}`.trim();
            }
            return updatedData;
        });
    };
    const handleDropDownChange = async ({ name, value }) => {
        setTransectionData(prev => ({ ...prev, [name]: value }));
    };
    const columnDefs = [
        { headerName: "Property Name", field: "createdBy", suppressMovable: true, width: 250, },
        { headerName: "Comm. %", field: "unitNo", suppressMovable: true, width: 150, },
    ]
    return (
        <div className="cost-center-section my-3">
            <div className={`border-box2 p-3`}>
                {tableLoading && (
                    <div
                        style={{
                            position: 'absolute',
                            inset: 0,
                            background: 'rgba(255,255,255,0.6)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}
                <div className='row'>
                    <div className='col-lg-8'>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Type *</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={transectionData.type}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'type', value: selectedOption })}
                                    options={customerTypeList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Mobile No *</label>
                                <div style={{ width: '100%' }}>
                                    <PhoneInput
                                        country={defaultCountry}
                                        value={transectionData.mobileNo}
                                        onChange={(value, country) => {
                                            setTransectionData(prev => ({
                                                ...prev,
                                                mobileNo: value,
                                                countryCode: country,
                                            }));
                                        }}
                                        enableSearch
                                    />
                                </div>
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">ID</label>
                                <input className="p-2 form-control w-75" value={transectionData?.id} disabled />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Phone No </label>
                                <div style={{ width: '75%' }}>
                                    <PhoneInput className="p-0"
                                        country={defaultCountry}
                                        value={transectionData.phoneNo}
                                        onChange={(value, country) => {
                                            setTransectionData(prev => ({
                                                ...prev,
                                                phoneNo: value,
                                                countryCode: country,
                                            }));
                                        }}
                                        enableSearch
                                    />
                                </div>
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> Name</label>
                                <input type="text" className="p-2 form-control w-75" value={transectionData?.name} onChange={handleInputChange} name="name" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Email ID *</label>
                                <input type="email" className="p-2 form-control w-75" value={transectionData?.email} onChange={handleInputChange} name="email" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Address </label>
                                <input type="text" className="p-2 form-control w-75" value={transectionData?.address} onChange={handleInputChange} name="address" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Commission Rate (%)</label>
                                <input type="text" className="p-2 form-control w-75" value={transectionData?.commissionRate} onChange={handleInputChange} name="commissionRate" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact Person </label>
                                <input type="text" className="p-2 form-control w-75" value={transectionData?.contactPerson} onChange={handleInputChange} name="contactPerson" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">International <br />Comm. Rate (%)</label>
                                <input type="text" className="p-2 form-control w-75" value={transectionData?.interCommRate} onChange={handleInputChange} name="interCommRate" />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Supplier</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={transectionData?.supplier}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'supplier', value: selectedOption })}
                                    options={salesPersonList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex gap-3">
                                <label className="form-check-label" htmlFor="createdtocheck">Active</label>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="active"
                                    style={{ width: '20px', height: '20px' }}
                                    checked={transectionData.active}
                                    onChange={(e) => setTransectionData(prev => ({ ...prev, active: e.target.checked }))}
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Agreement Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={transectionData?.agreementDate}
                                    onChange={(date) => handleDateChange({ name: 'agreementDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="d-flex">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Sales Person *</label>
                                <Select
                                    className="p-0 w-100"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    value={transectionData?.salePerson}
                                    onChange={(selectedOption) => handleDropDownChange({ name: 'salePerson', value: selectedOption })}
                                    options={salesPersonList?.map(country => ({ value: country, label: country?.text }))}
                                />
                            </div>
                            <div className="d-flex gap-3">
                                <label className="form-check-label" htmlFor="consultant">Supplier / Consultant</label>
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="consultant"
                                    style={{ width: '20px', height: '20px' }}
                                    checked={transectionData.consultant}
                                    onChange={(e) => setTransectionData(prev => ({ ...prev, consultant: e.target.checked }))}
                                />
                            </div>
                            <div className="d-flex mb-3">
                                <label htmlFor="validationCustom01" className="form-label pt-1 start">Limit</label>
                                <input type="number" className="p-2 form-control w-75" value={transectionData?.limit} onChange={handleInputChange} name="limit" />
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className="ag-theme-quartz" style={{ height: 650 }}>
                            <AgGridReact
                                getRowStyle={(params) => {
                                    if (params.node.rowIndex % 2 === 0) {
                                        return { background: "#F0EDF5" };
                                    } else {
                                        return { background: "#fff" };
                                    }
                                }}
                                rowData={rowData}
                                columnDefs={columnDefs}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};
export default AgentPersonalDetails;